import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intermediate-data-protection',
  templateUrl: './intermediate-data-protection.component.html',
  styleUrls: ['./intermediate-data-protection.component.scss']
})
export class IntermediateDataProtectionComponent implements OnInit {
  pt: string = 'pt-70';
  pb: string = 'pb-20'; 
  ptb: string = 'ptb-100'; 
  section: string = 'intermediate-data-protection'; 
  title: string = 'Consulta Nuestros Precios Sin Compromiso, Contáctanos.'; 

  constructor() { }

  ngOnInit(): void {
  }

}
